import $ from "jquery";
import videojs from "video.js";

function initModals() {
  const baseModals = $(".paid-modal");
  const overlay = $("#overlay");
  const players = new Map(); // Храним инстансы плееров

  // Функция для проверки и восстановления видимости оверлея
  function checkOverlayVisibility() {
    const activeModal = $(".paid-modal.active");
    if (activeModal.length && !overlay.is(":visible")) {
      overlay.fadeIn();
    }
  }

  // Проверяем видимость оверлея при фокусе на окне
  $(window).on('focus', checkOverlayVisibility);
  // Проверяем видимость оверлея при возвращении на вкладку
  document.addEventListener('visibilitychange', checkOverlayVisibility);

  if (baseModals.length) {
    baseModals.each(function () {
      const modal = $(this);
      const modalId = modal.data("event-source-id");
      const closeBtn = modal.find(".modal-close");
      const openBtn = $(`[data-modal="${modalId}"]`);
      let player = null;
      const videoElement = modal.find("video");

      // Инициализируем плеер один раз при загрузке
      if (videoElement.length) {
        // Проверяем, не инициализирован ли уже плеер
        player = videojs.getPlayer(videoElement[0]);
        if (!player) {
          player = videojs(videoElement[0], {
            controls: true,
            preload: 'auto',
            fluid: true,
            responsive: true,
            inactivityTimeout: 0,
            controlBar: {
              children: [
                'playToggle',
                'volumePanel',
                'progressControl',
                'currentTimeDisplay',
                'timeDivider',
                'durationDisplay',
                'fullscreenToggle'
              ]
            }
          });
          players.set(modalId, player);
          player.ready(() => {
            player.trigger('useractive');
          });
        }

        // --- Добавляем обработчики для ручного управления play/pause и прогрессом ---
        document.querySelector('video').addEventListener('play', () => {
          // Ищем кнопку только сейчас, когда control bar уже есть
          const playBtn = modal.find('.vjs-play-control')[0];
          if (playBtn) {
            playBtn.classList.add('vjs-playing');
            playBtn.classList.remove('vjs-paused');
          }
          player.trigger('useractive');
          player.trigger('timeupdate');
          document.dispatchEvent(new Event('visibilitychange'));
          player.trigger('resize');
          if (player.handleTechResize) player.handleTechResize();
          setTimeout(() => player.trigger('timeupdate'), 100);
          setTimeout(() => player.trigger('timeupdate'), 300);
        });
        document.querySelector('video').addEventListener('pause', () => {
          const playBtn = modal.find('.vjs-play-control')[0];
          if (playBtn) {
            playBtn.classList.remove('vjs-playing');
            playBtn.classList.add('vjs-paused');
          }
          player.trigger('useractive');
          player.trigger('timeupdate');
        });
      }

      if (openBtn.length && openBtn.data("modal") !== undefined) {
        openBtn.on("click", (e) => {
          modal.addClass("active");
          overlay.fadeIn();
          e.target.checked = false; // убираем включенный чекбокс

          if (player && videoElement.length) {
            const videoUrl = openBtn.data("modal-video-url");
            const videoType = openBtn.data("modal-video-type") || 'video/mp4';
            const source = {
              src: videoUrl,
              type: videoType
            };
            player.src(source);
            player.load();
          }
        });
      }

      if (closeBtn.length) {
        closeBtn.on("click", () => {
          modal.removeClass("active");
          overlay.fadeOut();
          if (player) {
            player.pause();
            player.trigger('useractive');
          }
        });
      }

      if (overlay.length) {
        overlay.on("click", () => {
          modal.removeClass("active");
          overlay.fadeOut();
          if (player) {
            player.pause();
            player.trigger('useractive');
          }
        });
      }
    });
  }

  window.addEventListener('focus', () => {
    videojs.getAllPlayers().forEach(player => {
      player.trigger('timeupdate');
      player.trigger('play');
      player.trigger('useractive');
    });
  });

  // Очистка ресурсов при уничтожении
  return function cleanup() {
    $(window).off('focus', checkOverlayVisibility);
    document.removeEventListener('visibilitychange', checkOverlayVisibility);
    players.forEach(player => {
      if (player) {
        player.dispose();
      }
    });
    players.clear();
  };
}

export default function () {
  return initModals();
}
